<template>
    <div class="flex flex-col px-8">
        <div v-if="isLoading" class="h-full flex flex-col justify-center items-center">
            <base-spinner></base-spinner>
        </div>
        <div v-else-if="!isLoading && !hasItems" class="h-full flex justify-center items-center">
            <h1 class="text-center text-xl font-medium py-16">No students found!</h1>
        </div>
        <div v-else class="flex flex-col">
            <div class="flex flex-col overflow-x-auto">
                <div class="inline-block min-w-full py-2">
                    <div class="overflow-x-auto">
                        <table class="min-w-full text-left text-sm font-light">
                            <thead class="border-b font-medium dark:border-neutral-500">
                                <tr>
                                    <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Student ID</th>
                                    <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                    <!-- <th scope="col" class="px-6 py-2 text-gray-400">Actions</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="index" class="border-b border-dashed dark:border-neutral-500">
                                    <td class="whitespace-nowrap px-6 py-2 font-medium">{{ paginatorInfo.firstItem + index }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <img class="h-12 w-12 rounded-lg object-cover cursor-pointer" :src="getProfilePicture(item.students.student_id, item.students.entity, item.profile_picture_url)" alt="">
                                            </div>
                                            <div class="flex-grow flex flex-col">
                                                <h1 class="text-sm font-semibold flex items-center">
                                                    <span class="text-heading">{{ item.name }}</span>
                                                </h1>
                                                <p class="text-xs text-gray-400">{{ item.email }}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.students.student_id }}</td>
                                    <td class="whitespace-nowrap px-6 py-2">{{ item.students.entity }}</td>
                                    <!-- <td class="px-6 py-2">
                                        <div class="flex">
                                            <div v-if="isShowApproveReject(item.is_approved)" @click.stop="updateApplication(item.id, true)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                <icon-approve class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                            </div>
                                            <div v-if="isShowApproveReject(item.is_approved)" @click.stop="rejectClicked(item.id)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                <icon-reject class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                            </div>
                                            <div v-if="hasPermission('jobs-show')" @click.stop="viewStudent(item)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                <icon-eye class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                            </div>
                                            <div v-if="hasPermission('jobs-edit')" @click.stop="editItem(item)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                <icon-pen class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-pen>
                                            </div>
                                            <div v-if="hasPermission('jobs-delete')" @click.stop="deleteItem(item.id)" class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                                                <icon-trash class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-trash>
                                            </div>
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mt-4">
                <pagination
                :paginatorInfo="paginatorInfo"
                :setPage="setPage"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import Pagination from "../../../components/shared/pagination.vue";
export default {
    name: 'job-accepted-students',
    props: ["jobId", "isApproved"],
    components: {
        Pagination,
    },
    data() {
        return {
            isLoading: false,
            error: null,
            first: 10,
            page: 1,
            hasItems: false,
            items: [],
            paginatorInfo: [],
        };
    },
    created() {
        this.fetchStudentsList();
    },
    methods: {
        async fetchStudentsList() {
            
            this.isLoading = true;

            const GET_JOBS_ACCEPTED_STUDENTS_QUERY = gql`
                query GetStudentsListPerJob($first: Int!, $page: Int!, $job_id: Int!, $is_approved: Boolean) {
                    getStudentsListPerJob(first: $first, page: $page, job_id: $job_id, is_approved: $is_approved) {
                        error
                        error_code
                        message
                        data {
                            id
                            name
                            email
                            profile_picture_url
                            students {
                                student_id
                                entity
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }
            `;

            try {
                await this.$apollo.query({
                    query: GET_JOBS_ACCEPTED_STUDENTS_QUERY,
                    fetchPolicy: 'network-only',
                    variables: {
                        first: this.first,
                        page: this.page,
                        job_id: parseInt(this.jobId),
                        is_approved: this.isApproved,
                    },
                }).then((data) => {
                    if (data.data.getStudentsListPerJob.error) {
                        this.error = data.data.getStudentsListPerJob.message;
                    } else {
                        this.items = data.data.getStudentsListPerJob.data;
                        this.paginatorInfo = data.data.getStudentsListPerJob.paginatorInfo;
                        this.hasItems = this.items.length > 0 ? true : false;
                    }
                }).catch((error) => {
                    this.error = error.message;
                })

            } catch (error) {
                this.error = error.message || "Please try again.";
            }

            this.isLoading = false;

        },
        getProfilePicture(studentId, entity, profilePictureUrl) {
            if (profilePictureUrl == '/storage/alumni-profile-pictures/default-avatar.jpg') {
                return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
            } else {
                return process.env.VUE_APP_PUBLIC_URL + profilePictureUrl;
            }
        },
        setPage(page) {
            this.page = page;
            this.fetchStudentsList();
        },
    },
}
</script>